import React from "react";
import GeneralIcon from "../../assets/icons/png/general-announcement-icon.png";
import TagIcon from "../../assets/icons/png/tag-level-announcement-icon.png";

type AnnouncementType = "general" | "tag-level";

interface AnnouncementTypeCardProps {
  type: AnnouncementType;
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
  showDescription?: boolean;
}

const AnnouncementTypeCard: React.FC<AnnouncementTypeCardProps> = ({
  type,
  isSelected = false,
  onClick,
  className = "",
  showDescription = true,
}) => {
  const getAnnouncementInfo = () => {
    if (type === "general") {
      return {
        title: "General announcement",
        description: showDescription
          ? "Represents content going to all screens or a wide audience."
          : "Represents content going to all screens without any specific tags.",
        icon: GeneralIcon,
      };
    } else {
      return {
        title: "Tag level announcement",
        description: showDescription
          ? "Represents content going to specific screens with specific tags."
          : "Represents content going to specific screens with specific tags.",
        icon: TagIcon,
      };
    }
  };

  const announcementInfo = getAnnouncementInfo();

  return (
    <div
      onClick={onClick}
      className={`
        w-full h-[88px]
        flex items-center gap-[12px]
        rounded-[10px] px-[16px] relative
        transition-all duration-200 border shadow-sm
        ${onClick ? "cursor-pointer" : "cursor-default"}
        ${
          isSelected
            ? "bg-[#F2FDFF] border-[#0BA6C7]"
            : "bg-white border-[#808191]"
        }
        ${onClick && !isSelected ? "hover:border-gray-400" : ""}
        ${className}
      `}
    >
      <div className="absolute left-[10px] w-[70.17px] h-[62.07px] flex items-center justify-center">
        <img
          src={announcementInfo.icon}
          alt={`${announcementInfo.title} Icon`}
          className="w-full h-full object-contain"
        />
      </div>

      <div className="ml-[80px] flex flex-col justify-center">
        <h3 className="text-sm font-semibold text-black mb-[4px] leading-tight">
          {announcementInfo.title}
        </h3>
        <p className="text-xs text-[#808191] leading-snug">
          {announcementInfo.description}
        </p>
      </div>
    </div>
  );
};

export default AnnouncementTypeCard;
